import parseHTML from "./dom/funciones/parse_html";
import {easeInOutQuad} from "./easing";

const SwipeIt = require('./swipe-it');

interface OpcionesGaleria {
    duracion?: number,
    easing?: (t: number) => number,
    elementosDeMas?: number,
    onCambioStart?: (indice: number) => void,
    onCambio?: (indice: number, progreso: number) => void,
    onCambioEnd?: (indice: number) => void,
}

// Repite las imágenes para que haya al menos "cantidad"
const completaImagenes = (imagenes: HTMLElement[], cantidad: number) => {
    for (let i = 0; i < cantidad - imagenes.length; i++) {
        imagenes.push(imagenes[i % imagenes.length].cloneNode(true) as HTMLElement);
    }
}

// Añade las "elementosDeMas" primeras y las "elementosDeMas" últimas imágenes al final y al principio del array
const creaImagenesParaDesplazar = (imagenes: HTMLElement[], elementosDeMas: number) => {
    return [
        ...imagenes.slice(imagenes.length - elementosDeMas),
        ...imagenes,
        ...imagenes.slice(0, elementosDeMas),
    ].map(x => x.cloneNode(true) as HTMLElement)
}

const galeria = (contenedor: HTMLElement, opciones?: OpcionesGaleria) => {
    const {duracion, easing, elementosDeMas, onCambioEnd, onCambioStart, onCambio} = {
        duracion: 500,
        easing: easeInOutQuad,
        elementosDeMas: 2,
        onCambioStart: (x: number) => {
        },
        onCambioEnd: (x: number) => {
        },
        onCambio: (x: number, y: number) => {
        },
        ...opciones,
    };

    let imagenesVisibles: HTMLElement[] = [],
        indice = elementosDeMas,
        destino = -100 * elementosDeMas,
        actual = destino,
        actualizando = false;

    const carrusel = contenedor.querySelector('.slides') as HTMLElement,
        imagenes = [].slice.call(contenedor.querySelectorAll('.slide')) as HTMLElement[];

    if (imagenes.length === 1) {
        return;
    }

    completaImagenes(imagenes, 1 + elementosDeMas * 2);

    const
        todasLasImagenes = creaImagenesParaDesplazar(imagenes, elementosDeMas),
        primero = elementosDeMas,
        ultimo = todasLasImagenes.length - elementosDeMas,
        anterior = parseHTML('<button class="galeria__anterior">Anterior</button>') as HTMLButtonElement,
        siguiente = parseHTML('<button class="galeria__siguiente">Siguiente</button>') as HTMLButtonElement,
        actualiza = () => new Promise(resolve => {
            // Desplazamos para que esté siempre centrado en la imagen central
            carrusel.style.transform = `translateX(-${elementosDeMas * 100}%)`;
            imagenesVisibles.forEach(imagen => imagen.remove());
            imagenesVisibles = todasLasImagenes.slice(indice - elementosDeMas, indice + elementosDeMas + 1);
            imagenesVisibles.forEach(imagen => carrusel.appendChild(imagen));
        }),
        desplaza = (direccion: number) => () => {
            if (actualizando) {
                return;
            }

            indice = indice + direccion;
            if (indice === ultimo) {
                indice = primero;
            } else if (indice < primero) {
                indice = ultimo - 1;
            }

            actualizando = true;

            destino = direccion > 0 ? actual - 100 : actual + 100;

            const inicio = actual,
                distancia = destino - actual,
                siguienteIndice = indice - 1;

            onCambioStart(siguienteIndice);
            const startTime = 'now' in window.performance ? performance.now() : new Date().getTime();

            const mueve = () => {
                const now = 'now' in window.performance ? performance.now() : new Date().getTime();
                const transcurrido = now - startTime;
                const time = easing(Math.min(transcurrido / duracion, 1))

                actual = inicio + distancia * time;
                carrusel.style.transform = `translateX(${actual}%)`;

                if (time === 1) {
                    actual = -elementosDeMas * 100;
                    actualizando = false;

                    onCambioEnd(siguienteIndice);
                    actualiza();
                } else {
                    onCambio(siguienteIndice, time);
                    requestAnimationFrame(mueve);
                }
            }
            mueve();
        },
        avanza = desplaza(1),
        retrocede = desplaza(-1);


    if (imagenes.length > 1) {
        imagenes.forEach(imagen => imagen.remove());

        actualiza();

        anterior.addEventListener('click', retrocede);
        siguiente.addEventListener('click', avanza);

        const swipeIt = new SwipeIt(contenedor);
        swipeIt.on('swipeLeft', avanza);
        swipeIt.on('swipeRight', retrocede);

        contenedor.appendChild(anterior);
        contenedor.appendChild(siguiente);
    }
};

export default galeria;